import React from 'react';
import { Icon } from '../SvgIcon';
import styles from './WinCard.module.scss';
import { useModuleClick } from '../Layout/lxContext';
import { useWinCardClickParams } from './hooks/useLxParams';

interface IProps {
  cardName: string;
  cardDec: string;
  cardLink: string;
  winDetailText: string;
}

const defaultUrl = 'https://123.meituan.com/v3';

function WinCard(props: IProps) {
  const { cardName, cardDec, cardLink, winDetailText } = props;
  const moduleClick = useModuleClick();
  const lxParams = useWinCardClickParams({ cardName, cardLink });
  const handleClick = () => {
    moduleClick?.(lxParams);
  };
  return (
    <a href={cardLink || defaultUrl} target="_blank" rel="noreferrer">
      <div className={styles['win-card-box']} onClick={handleClick}>
        <div className={styles['win-card-con-warp']}>
          <span className={styles['win-card-name']}>{cardName}</span>
          <p className={styles['win-card-dec']}>{cardDec}</p>
          <button className={styles['win-card-btn-detail']}>
            {winDetailText}
            <Icon className="ml-[4px] inline align-[-2px]" name="arrow-right-detail" width={14} height={14} />
          </button>
        </div>
      </div>
    </a>
  );
}

export default WinCard;
